import React from "react";
import Link from "./link";
import classNames from "classnames"

const PageHeader = ({ title, name, subRoute, secondSubRoute }) => {

  const backgroundClass = {
    About: "about-bg",
    Contact: "contact-bg",
    Products: "product-bg",
    default: "default-bg"
  };

  return (
    <section className={classNames(
      "breadcrumb_section text-center section_padding",
      backgroundClass[name] || backgroundClass?.default
    )}
    >
      <ul className="breadcrumb">
        <li>
          <Link href="/">Home</Link>
        </li>
        <li>{name}</li>
        {subRoute && <li>{subRoute}</li>}
        {secondSubRoute && <li>{secondSubRoute}</li>}
      </ul>
      <h1>{title}</h1>
    </section>
  );
};

export default PageHeader;
